module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notificationContainer"
  }, [(_vm.objAuthorize.department_active == 1) ? _c('v-flex', {
    staticClass: "filterNotificationsDeps"
  }, [_c('v-select', {
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.departmentListSet,
      "item-text": "name",
      "item-value": "id",
      "solo": "",
      "outline": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncFilterNotifications()
      }
    },
    model: {
      value: (_vm.filterDepartment),
      callback: function($$v) {
        _vm.filterDepartment = $$v
      },
      expression: "filterDepartment"
    }
  }), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.statusListSet,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(props.item.show == true) ? _c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "70%"
          }
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(_vm.fncGetCount(props.item.id)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncShowNotifications(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("add_alert")])])])]) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}